import React from "react";
import Navbar from "./Navbar";

const values = [
  {
    title: "Transparency",
    desc: "Every rand is tracked publicly. No hidden fees, no back room deals. Contributors see exactly where their money goes, every step of the way.",
    iconBg: "#EDE8DF",
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#1B3A6B" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/>
      </svg>
    ),
  },
  {
    title: "Dignity Over Charity",
    desc: "This is not about pity. This is about power. Every South African who contributes is a builder, not a donor. Every community that benefits is empowered, not rescued.",
    iconBg: "rgba(201,168,76,0.12)",
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#C9A84C" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/>
      </svg>
    ),
  },
  {
    title: "Action Over Rage",
    desc: "Social media rage does not build anything. Forge SA turns frustration into funded, tangible, real world change. One project at a time. One community at a time.",
    iconBg: "rgba(46,125,50,0.1)",
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#2E7D32" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
      </svg>
    ),
  },
  {
    title: "No One Left Behind",
    desc: "Not by age. Not by education. Not by province. Not by background. Forge SA was built for every South African, especially those the system forgot.",
    iconBg: "rgba(91,155,213,0.12)",
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#5B9BD5" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/>
      </svg>
    ),
  },
  {
    title: "Accountability",
    desc: "Funds are protected by Forge Vault. Every milestone is independently confirmed before a single rand is released. No exceptions.",
    iconBg: "rgba(27,58,107,0.07)",
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#1B3A6B" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
      </svg>
    ),
  },
  {
    title: "Local First",
    desc: "Jobs go to local workers. Roads serve local families. Schools educate local children. Every project puts the community that funded it first.",
    iconBg: "rgba(46,125,50,0.1)",
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#2E7D32" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/>
      </svg>
    ),
  },
];

const steps = [
  {
    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1B3A6B" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 8v4l3 3"/></svg>,
    title: "Suggest",
    desc: "Communities suggest projects that address real local needs.",
  },
  {
    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1B3A6B" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>,
    title: "Verify",
    desc: "Forge SA independently verifies budgets, plans and milestones.",
  },
  {
    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1B3A6B" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M16 8h-6a2 2 0 000 4h4a2 2 0 010 4H8M12 6v2M12 16v2"/></svg>,
    title: "Fund",
    desc: "South Africans contribute any amount from R10. Every rand goes to Forge Vault for safekeeping.",
  },
  {
    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#C9A84C" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>,
    title: "Build",
    desc: "Funds are released by Forge Vault as verified milestones are completed by community cooperatives.",
  },
  {
    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#2E7D32" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2a9 9 0 019 9c0 4-2.5 7.5-6 9M12 2a9 9 0 00-9 9c0 4 2.5 7.5 6 9M12 2v18"/></svg>,
    title: "Grow",
    desc: "Completed projects generate profits and community decisions that fund the next project.",
  },
];

export default function About() {
  return (
    <div style={{ fontFamily: "var(--font-body)", background: "#F5F0E8", minHeight: "100vh", color: "#1A1A2E" }}>

      <style>{`
        .about-header { padding: 56px 48px 48px; }
        .about-section { max-width: 860px; margin: 0 auto; padding: 56px 48px 0; }
        .about-section-sm { max-width: 860px; margin: 0 auto; padding: 40px 48px 0; }
        .about-card { background: #fff; border: 1px solid #EDE8DF; border-radius: 20px; padding: 40px 48px; }
        .about-promise-card { background: #1B3A6B; border: 1px solid #1B3A6B; border-radius: 20px; padding: 40px 48px; }
        .about-values { max-width: 1100px; margin: 0 auto; padding: 56px 48px 0; }
        .about-values-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 20px; }
        .about-steps-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); gap: 14px; margin-top: 24px; }
        .about-cta { padding: 64px 48px; margin-top: 72px; }
        @media (max-width: 768px) {
          .about-header { padding: 36px 20px 32px; }
          .about-section { padding: 32px 20px 0; }
          .about-section-sm { padding: 24px 20px 0; }
          .about-card { padding: 24px 20px; border-radius: 16px; }
          .about-promise-card { padding: 28px 20px; border-radius: 16px; }
          .about-values { padding: 32px 20px 0; }
          .about-values-grid { grid-template-columns: 1fr; gap: 14px; }
          .about-steps-grid { grid-template-columns: 1fr 1fr; gap: 10px; }
          .about-cta { padding: 48px 20px; margin-top: 40px; }
          .about-cta button { width: 100%; }
        }
        @media (max-width: 480px) {
          .about-steps-grid { grid-template-columns: 1fr; }
        }
      `}</style>

      <Navbar active="About" />

      {/* HEADER */}
      <div className="about-header" style={{ background: "#fff", borderBottom: "1px solid #EDE8DF", textAlign: "center" }}>
        <div style={{ display: "inline-block", background: "rgba(27,58,107,0.07)", border: "1px solid rgba(27,58,107,0.15)", borderRadius: 99, padding: "5px 16px", fontSize: 11, color: "#1B3A6B", fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 20 }}>
          Our Story
        </div>
        <h1 style={{ fontSize: "clamp(28px, 5vw, 52px)", fontWeight: 900, color: "#1A1A2E", letterSpacing: "-0.02em", margin: "0 0 16px", lineHeight: 1.1 }}>
          Built by <span style={{ color: "#1B3A6B" }}>South Africans.</span><br />
          For <span style={{ color: "#C9A84C" }}>South Africa.</span>
        </h1>
        <p style={{ fontSize: 16, color: "#888", lineHeight: 1.8, maxWidth: 560, margin: "0 0 20px auto", textAlign: "center" }}>
          One platform. One mission. One nation building itself.
        </p>
        <p style={{ fontSize: 15, color: "#1B3A6B", fontWeight: 700, lineHeight: 1.8, maxWidth: 640, margin: "0 auto", fontStyle: "italic" }}>
          Forge SA believes that South Africa's greatest resource is not its minerals, its land, or its institutions. It is its people, working together.
        </p>
      </div>

      {/* VISION */}
      <div className="about-section">
        <div style={{ display: "inline-block", background: "rgba(27,58,107,0.07)", border: "1px solid rgba(27,58,107,0.15)", borderRadius: 99, padding: "5px 16px", fontSize: 11, color: "#1B3A6B", fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 20 }}>
          Our Vision
        </div>
        <div className="about-card">
          <p style={{ fontSize: 15, color: "#4A4A6A", lineHeight: 1.9, marginBottom: 20 }}>
            We see South Africans coming together to build the future they deserve. Ordinary people pooling their rands to create jobs, housing, schools, infrastructure and opportunities, working alongside existing systems to fill the gaps communities feel most urgently.
          </p>
          <p style={{ fontSize: 15, color: "#4A4A6A", lineHeight: 1.9, marginBottom: 20 }}>
            A South Africa where a 35-year-old is not told they are too old to work. Where someone who never finished school is not dismissed. Where families in Limpopo, Eastern Cape or anywhere else do not have to send their children away to Johannesburg or Cape Town just to survive.
          </p>
          <p style={{ fontSize: 15, color: "#4A4A6A", lineHeight: 1.9, marginBottom: 20 }}>
            Where every South African deserves the opportunity to own a home. Where communities grow with dignity and no one is left behind.
          </p>
          <p style={{ fontSize: 17, fontWeight: 800, color: "#1B3A6B", lineHeight: 1.6 }}>
            We are not waiting for change. We are forging it, together.
          </p>
        </div>
      </div>

      {/* MISSION */}
      <div className="about-section-sm">
        <div style={{ display: "inline-block", background: "rgba(201,168,76,0.1)", border: "1px solid rgba(201,168,76,0.3)", borderRadius: 99, padding: "5px 16px", fontSize: 11, color: "#8a6a1a", fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 20 }}>
          Our Mission
        </div>
        <div className="about-card">
          <p style={{ fontSize: 15, color: "#4A4A6A", lineHeight: 1.9, marginBottom: 20 }}>
            Forge SA is a platform where communities invest in themselves. South Africans directly fund and build community-owned projects that create real jobs and lasting opportunity.
          </p>
          <p style={{ fontSize: 20, fontWeight: 900, color: "#1B3A6B", lineHeight: 1.3, marginBottom: 20 }}>
            This is collective ownership of development. This is not crowdfunding.
          </p>
          <p style={{ fontSize: 15, color: "#4A4A6A", lineHeight: 1.9, marginBottom: 20 }}>
            Every rand is held by Forge Vault. Every milestone is independently checked before funds are released. Every project is tracked with proof, so when ordinary people come together, something real gets built.
          </p>
          <p style={{ fontSize: 15, color: "#4A4A6A", lineHeight: 1.9 }}>
            Forge SA complements and works alongside existing civic and government structures, filling the gaps at community level where people feel the need most urgently. We are not here to replace anything. We are here to empower everyone.
          </p>
        </div>
      </div>

      {/* WHY WE EXIST */}
      <div className="about-section-sm">
        <div style={{ display: "inline-block", background: "rgba(46,125,50,0.08)", border: "1px solid rgba(46,125,50,0.2)", borderRadius: 99, padding: "5px 16px", fontSize: 11, color: "#2E7D32", fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 20 }}>
          Why We Exist
        </div>
        <div className="about-card">
          <p style={{ fontSize: 15, color: "#4A4A6A", lineHeight: 1.9, marginBottom: 20 }}>
            South Africa faces deep challenges. Unemployment. Limited access to opportunity. Communities where skills, ambition and hard work exist in abundance but the infrastructure to channel them into lasting change has not always reached far enough.
          </p>
          <p style={{ fontSize: 17, fontWeight: 800, color: "#C0392B", lineHeight: 1.6, marginBottom: 20 }}>
            We believe ordinary South Africans can be part of the solution.
          </p>
          <p style={{ fontSize: 15, color: "#4A4A6A", lineHeight: 1.9, marginBottom: 20 }}>
            Forge SA exists so that every South African, from all backgrounds and provinces, has a transparent, trusted and accountable platform to pool resources and build something real for their community.
          </p>
          <p style={{ fontSize: 17, fontWeight: 800, color: "#2E7D32", lineHeight: 1.6 }}>
            One project, one rand, one community at a time.
          </p>
        </div>
      </div>

      {/* HOW IT WORKS */}
      <div className="about-section-sm">
        <div style={{ display: "inline-block", background: "rgba(91,155,213,0.1)", border: "1px solid rgba(91,155,213,0.3)", borderRadius: 99, padding: "5px 16px", fontSize: 11, color: "#185FA5", fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 20 }}>
          How It Works
        </div>
        <div className="about-card">
          <p style={{ fontSize: 15, color: "#4A4A6A", lineHeight: 1.9, marginBottom: 24 }}>
            Communities suggest projects. Verified proposals are published on Forge SA. South Africans choose which projects to support. Funds remain protected by Forge Vault until independently verified milestones are completed. Successful projects create lasting value that strengthens future community development.
          </p>
          <div className="about-steps-grid">
            {steps.map((s, i) => (
              <div key={i} style={{ background: "#F5F0E8", border: `1px solid ${i === 3 ? "rgba(201,168,76,0.3)" : i === 4 ? "rgba(46,125,50,0.2)" : "#EDE8DF"}`, borderRadius: 14, padding: 18, textAlign: "center" }}>
                <div style={{ width: 44, height: 44, background: "#fff", borderRadius: 12, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 12px" }}>
                  {s.icon}
                </div>
                <div style={{ fontSize: 13, fontWeight: 800, color: "#1A1A2E", marginBottom: 6 }}>{s.title}</div>
                <div style={{ fontSize: 11, color: "#888", lineHeight: 1.6 }}>{s.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* OUR PROMISE */}
      <div className="about-section-sm">
        <div style={{ display: "inline-block", background: "rgba(27,58,107,0.07)", border: "1px solid rgba(27,58,107,0.15)", borderRadius: 99, padding: "5px 16px", fontSize: 11, color: "#1B3A6B", fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 20 }}>
          Our Promise
        </div>
        <div className="about-promise-card">
          <p style={{ fontSize: 15, color: "rgba(184,212,232,0.9)", lineHeight: 1.9, marginBottom: 20 }}>
            Every rand is protected by Forge Vault. Every milestone is verified before money moves. You will see photos, updates and full reports of what you helped build.
          </p>
          <p style={{ fontSize: 15, color: "rgba(184,212,232,0.9)", lineHeight: 1.9, marginBottom: 20 }}>
            Zero hidden fees. Zero disappearing funds. Zero empty promises.
          </p>
          <p style={{ fontSize: 15, color: "rgba(184,212,232,0.9)", lineHeight: 1.9, marginBottom: 28 }}>
            We are builders. South Africans investing in South Africa, together.
          </p>
          <p style={{ fontSize: 22, fontWeight: 900, color: "#C9A84C", lineHeight: 1.4 }}>
            We are forging. Join us.
          </p>
        </div>
      </div>

      {/* VALUES */}
      <div className="about-values">
        <h2 style={{ fontSize: "clamp(24px, 4vw, 36px)", fontWeight: 900, textAlign: "center", margin: "0 0 40px", letterSpacing: "-0.02em", color: "#1A1A2E" }}>
          What We Stand <span style={{ color: "#1B3A6B" }}>For</span>
        </h2>
        <div className="about-values-grid">
          {values.map((val, i) => (
            <div key={i} style={{ background: "#fff", border: "1px solid #EDE8DF", borderRadius: 16, padding: 28 }}>
              <div style={{ width: 48, height: 48, borderRadius: 12, background: val.iconBg, display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 16 }}>
                {val.icon}
              </div>
              <div style={{ fontSize: 17, fontWeight: 800, color: "#1A1A2E", marginBottom: 10 }}>{val.title}</div>
              <div style={{ fontSize: 13, color: "#888", lineHeight: 1.75 }}>{val.desc}</div>
            </div>
          ))}
        </div>
      </div>

      {/* CTA */}
      <section className="about-cta" style={{ background: "#1B3A6B", textAlign: "center" }}>
        <h2 style={{ fontSize: "clamp(24px, 4vw, 40px)", fontWeight: 900, color: "#fff", margin: "0 0 14px", letterSpacing: "-0.02em" }}>
          Ready to <span style={{ color: "#C9A84C" }}>Forge</span> South Africa?
        </h2>
        <p style={{ color: "rgba(184,212,232,0.8)", fontSize: 15, marginBottom: 28, maxWidth: 480, margin: "0 auto 28px" }}>
          Join thousands of South Africans who stopped waiting and started building.
        </p>
        <button
          onClick={() => window.location.href = "/register"}
          style={{ background: "#C9A84C", border: "none", borderRadius: 99, padding: "14px 36px", color: "#fff", fontWeight: 700, fontSize: 15, cursor: "pointer", fontFamily: "var(--font-body)" }}>
          Join the Movement
        </button>
        <div style={{ marginTop: 32, fontSize: 12, color: "rgba(184,212,232,0.35)" }}>
          Forge SA. Built by us. For us.
        </div>
      </section>

    </div>
  );
}